
import { EventType, trackEvent } from "@/helpers/AmplitudeHelper";
import { defineComponent } from "vue";
import { mapActions, mapGetters } from "vuex";
import * as amplitude from '@amplitude/analytics-browser';

export default defineComponent({
  name: "SidebarTender",
  computed: {
    ...mapGetters(["isAuthenticated", "getTender"]),
    isFavourite() {
      return !!this.$store.getters.getTender.fav_id
    }
  },
  methods: {
    ...mapActions(["toggleAuthModal", "addFavourite", "deleteFavourite"]),
    async handleSavePurchase() {
      await this.addFavourite({ 
        tenderId: this.getTender.id, 
        notificationMessage: this.$t('notifications.add_favourite') 
      })

      const identifyEvent = new amplitude.Identify();
      identifyEvent.add('favourites', 1);
      amplitude.identify(identifyEvent);
      trackEvent(EventType.purchase_save, { purchase_id: this.getTender.id })
    },
    async handleDeletePurchase() {
      await this.deleteFavourite({ 
        tenderId: this.getTender.id, 
        favId: this.getTender.fav_id, 
        notificationMessage: this.$t('notifications.delete_favourite')
      })

      const identifyEvent = new amplitude.Identify();
      identifyEvent.add('favourites', -1);
      amplitude.identify(identifyEvent);
      trackEvent(EventType.purchase_delete, { purchase_id: this.getTender.id })
    },
    handleOpenSource() {
      trackEvent(EventType.purchase_source_open, { url: this.getTender.url })
    }
  }
});
